import React, { Component } from 'react';
import { Box, Button, Typography } from "@mui/material";
import Logo from './components/Logo';
class ErrorBoundary extends Component {
  state = {
    hasError: false,
    errorMessage: '',
  };

  static getDerivedStateFromError(error) {
    return {
      hasError: true,
      errorMessage: error.message,
    };
  }
  
  componentDidCatch(error, errorInfo) {
    console.error(error, errorInfo);
  }

  handleReload() {
    location.reload();
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex items-center justify-center h-screen">
          <div className="p-6 border rounded-lg hover:shadow-md item-center text-center">
            <Logo />
            <h2 className="text-xl text-capitalize font-bold mb-4">Attention</h2>
            <p className="text-gray-600 mb-4"> 
            <strong>Oups. Nous somme désolé ! Une erreur est survenue au cours du processus.</strong> <br />
             Veuillez reporté l'erreur au support technique pour une prise en charge Merci.
             </p>
            <button className="bg-green-500 hover:bg-green-600 text-white font-bold py-2 px-4 focus:outline-none" 
            onClick={()=>handleReload()}>
              Actualiser la page
            </button>
          </div>
      </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;